import { render, staticRenderFns } from "./ZyroText.vue?vue&type=template&id=1437afd8&scoped=true&"
var script = {}
import style0 from "./ZyroText.vue?vue&type=style&index=0&id=1437afd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437afd8",
  null
  
)

export default component.exports